import Vue from 'vue'

type Modals = 'welcomeModal' | 'plugPianoSlide' | 'introPlayerModal' | 'classPanel' | 'keyboardSlide' | 'successModal'

interface PlayerModalsState {
  isActionBarDisplayed: boolean
  isFirstDisplayOfWelcomeModal: boolean
  isTranspositionModalDisplayed: boolean
  activeModals: Modals[]
}

class PlayerModals {
  public readonly state = Vue.observable<PlayerModalsState>({
    isActionBarDisplayed: true,
    activeModals: [],
    isFirstDisplayOfWelcomeModal: true,
    isTranspositionModalDisplayed: false
  })

  public setIsModalDisplayed(modalName: Modals, value: boolean) {
    const index = this.state.activeModals.indexOf(modalName);
    if (value && index === -1) {
      this.state.activeModals.push(modalName);
    }
    else if (!value && index !== -1) {
      this.state.activeModals.splice(index, 1);
    }
    if (modalName === 'welcomeModal') {
      this.state.isFirstDisplayOfWelcomeModal = true
    }
  }
}

export const playerModals = new PlayerModals()
